export default function Snowflake({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M20.7892 13.95L18.4592 14.57L16.4592 13.44V10.56L18.4592 9.43L20.7892 10.05L21.3092 8.12L19.5392 7.65L19.9992 5.88L18.0692 5.36L17.4492 7.69L15.4492 8.82L12.9992 7.38V5.12L14.7092 3.41L13.2892 2L11.9992 3.29L10.7092 2L9.28922 3.41L10.9992 5.12V7.38L8.49922 8.82L6.49922 7.69L5.91922 5.36L3.99922 5.88L4.46922 7.65L2.69922 8.12L3.21922 10.05L5.54922 9.43L7.54922 10.56V13.45L5.54922 14.58L3.21922 13.96L2.69922 15.89L4.46922 16.36L3.99922 18.12L5.92922 18.64L6.54922 16.31L8.54922 15.18L10.9992 16.62V18.88L9.28922 20.59L10.7092 22L11.9992 20.71L13.2892 22L14.6992 20.59L12.9992 18.88V16.62L15.4992 15.17L17.4992 16.3L18.1192 18.63L19.9992 18.12L19.5292 16.35L21.2992 15.88L20.7892 13.95ZM9.49922 10.56L11.9992 9.11L14.4992 10.56V13.44L11.9992 14.89L9.49922 13.44V10.56Z"
        fill="currentColor"
      />
    </svg>
  );
}
